import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import IntelligenceAnalytics from "@/pages/IntelligenceAnalytics";

export const Route = createFileRoute("/_app/intelligence/analytics")({
  component: () => (
    <PageGate pageKey="intelligence"><IntelligenceAnalytics /></PageGate>
  ),
});
